import BaseEnum from "./base_enum.js";

class IdentificationStatusFilterModeEnumDesc extends BaseEnum {

  name() {
    return "identification_status_filter_mode";
  }

  rawValues() {
    return ["true", "false"];
  }

}

const IdentificationStatusFilterModeEnum = new IdentificationStatusFilterModeEnumDesc();
export default IdentificationStatusFilterModeEnum;